<template>
    <SidebarChild :selected-item="value" :items="getMenuItems()" :focusActive="true" @selected="selectedItem" />
</template>
<script>
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import MenuItems from "./MenuItems";
import { mapGetters, mapState } from "vuex";

export default {
    name: "ChatSidebar",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
    },
    computed: {
        ...mapState({
            liveVisitorCount: (state) => state.visitor.liveVisitorCount,
            chatTotal: (state) => state.chat.stats.total,
            unreadMessages: (state) => state.team.unreadMessages.filter((chat) => chat.unreadCount > 0).length,
            chatbotLive: (state) => state.chat.stats.chatbot,
            websiteTrackingUrl: (state) => state.setting.settings?.websiteTrackingUrl,
            whatsappChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("whatsapp")),
            messengerChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("messenger")),
            instagramChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("instagram")),
            metaLeadsChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("meta-lead")),
            channels: (state) => state.channel.channels,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    data: () => ({
        MenuItems: [],
    }),
    mounted() {
        this.MenuItems = this.getMenuItems();
    },
    created() {
        this.MenuItems = this.getMenuItems();
    },
    methods: {
        selectedItem({ key }) {
            this.$emit("input", key);
        },
        getMenuItems() {
            console.log("getMenuItems...");
            return [
                {
                    enabled: true,
                    key: 0,
                    label: this.$t("message.liveSupport"),
                    icon: {
                        type: "material-icons",
                        name: "support_agent",
                    },
                    dataKey: "liveSupport",
                },
                {
                    enabled: true,
                    key: 6,
                    label: this.$t("message.teamChat"),
                    counter: this?.unreadMessages,
                    icon: {
                        type: "material-icons",
                        name: "group",
                    },
                    dataKey: "teamChat",
                },
                {
                    enabled: true,
                    key: 1,
                    label: this.$t("message.siteVisitors"),
                    counter: this?.liveVisitorCount,
                    icon: {
                        type: "material-icons",
                        name: "public",
                    },
                    dataKey: "siteVisitors",
                },
                {
                    enabled: true,
                    key: 2,
                    label: this.$t("message.conversationHistory"),
                    icon: {
                        type: "material-icons",
                        name: "history",
                    },
                    dataKey: "conversationHistory",
                },
                {
                    enabled: true,
                    key: 3,
                    label: this.$t("message.representative"),
                    icon: {
                        type: "material-icons",
                        name: "engineering",
                    },
                    dataKey: "representative",
                },
                {
                    enabled: this?.whatsappChannelExists,
                    key: 5,
                    label: this.$t("WhatsappContacts"),
                    icon: {
                        type: "component",
                        name: "WhatsappIcon",
                    },
                    dataKey: "whatsappContacts",
                },
                {
                    enabled: this?.instagramChannelExists,
                    key: 9,
                    label: this.$t("InstagramContacts"),
                    icon: {
                        type: "component",
                        name: "InstagramIcon",
                    },
                    dataKey: "instagramContacts",
                },
                {
                    enabled: this?.messengerChannelExists,
                    key: 10,
                    label: this.$t("MessengerContacts"),
                    icon: {
                        type: "component",
                        name: "MessengerIcon",
                    },
                    dataKey: "messengerContacts",
                },
                {
                    enabled: this?.metaLeadsChannelExists,
                    key: 14,
                    label: "Meta Leads",
                    icon: {
                        type: "component",
                        name: "MetaIcon",
                    },
                    dataKey: "metaLeads",
                },
                {
                    enabled: true,
                    key: 7,
                    label: this.$t("notification.activities"),
                    icon: {
                        type: "material-icons",
                        name: "rss_feed",
                    },
                    dataKey: "activities",
                },
                {
                    enabled: !!this?.websiteTrackingUrl,
                    key: 12,
                    label: "Website Analytics",
                    icon: {
                        type: "material-icons",
                        name: "analytics",
                    },
                    dataKey: "websiteAnalytics",
                },
                {
                    enabled: true,
                    key: 13,
                    label: this.$t("automation.automations"),
                    icon: {
                        type: "component",
                        name: "atomic-power",
                        class: "myIcon",
                        style: { fill: "var(--color-icon-primary-default)" },
                    },
                    dataKey: "automations",
                },
            ];
        },
    },
    watch: {
        liveVisitorCount() {
            this.MenuItems = this.getMenuItems();
        },
        chatTotal() {
            this.MenuItems = this.getMenuItems();
        },
        unreadMessages() {
            this.MenuItems = this.getMenuItems();
        },
        chatbotLive() {
            this.MenuItems = this.getMenuItems();
        },
        channels: {
            deep: true,
            handler() {
                this.MenuItems = this.getMenuItems();
            },
        },
    },
};
</script>
